import { writable } from "svelte/store";

export const plansData = writable({});

export const topicData = writable({});

export const selectedPlanIds = writable(new Set([]));
